'use strict';
const sticky = document.querySelector('.sticky');
const heroButton = document.querySelector('.hero .button');
function updateSticky() {
  sticky.hidden = heroButton.getBoundingClientRect().bottom >= 0;
}
window.addEventListener('scroll', updateSticky, { passive: true });
window.addEventListener('resize', updateSticky);
updateSticky();


const imageDialog = document.getElementById('image-dialog');
const enlargedImage = imageDialog.querySelector('img');
let imageTrigger;
document.querySelectorAll('.image-filled').forEach(button => button.addEventListener('click', () => {
  imageTrigger = button;
  const image = button.querySelector('img');
  enlargedImage.src = image.src;
  enlargedImage.alt = image.alt;
  enlargedImage.width = image.naturalWidth;
  enlargedImage.height = image.naturalHeight;
  imageDialog.showModal();
  document.body.style.overflow = 'hidden';
}));
imageDialog.querySelector('button').addEventListener('click', () => imageDialog.close());
imageDialog.addEventListener('click', event => { if (event.target === imageDialog) imageDialog.close(); });
imageDialog.addEventListener('close', () => {
  document.body.style.overflow = '';
  enlargedImage.removeAttribute('src');
  if (imageTrigger) imageTrigger.focus();
});
